import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=46b7b406"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b7b406')) {
      api.createRecord('46b7b406', component.options)
    } else {
      api.reload('46b7b406', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=46b7b406", function () {
      api.rerender('46b7b406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applocalizations/detail.vue"
export default component.exports